import { Box, Grid } from '@mui/material'
import { format, parseISO } from 'date-fns'
import CardSectionHeader from './CardSectionHeader'
import React from 'react'
import styled from 'styled-components'

const ContactSection = styled(Grid)`
	padding: 1.25rem;
	border-right: 1px solid rgba(0, 0, 0, 0.12);
`

const AccountInfoLabel = styled(Grid)`
	display: inline-block;
	font-weight: normal;
	font-size: 16px;
	line-height: 1.375rem;
`

const AccountInfoValue = styled(Grid)`
	display: inline-block;
	font-weight: 500;
	font-size: 16px;
	line-height: 1.25rem;
`

const ContactLabel = styled.span`
	flex-grow: 1;
`

const ContactField = ({ label, children }) => {
  return (
    <Grid container item spacing={1} xs={12}>
      <AccountInfoLabel item xs={4}>
        <div>{label}</div>
      </AccountInfoLabel>
      <AccountInfoValue item xs={8}>
        <div>{children}</div>
      </AccountInfoValue>
    </Grid>
  )
}

const ContactInfo = ({ profile }) => {
  const phone = profile.phone
  const formattedPhoneNumber = `${phone.substring(0, 3)}-${phone.substring(
    3,
    6,
  )}-${phone.substring(6)}`
  const modifiedDate = parseISO(profile.modifiedDate)
  const formattedDate = format(modifiedDate, 'M-d-yyyy')
  const imagesUrl = process.env.REACT_APP_IMAGES_URL
  const src = `${imagesUrl}/icon/aws-chip.svg`
  const cognitoImage = <img alt="AWS Cognito Account" src={src} />
  const phoneLabel = profile.hasCognitoAccountWithPhone ? 'Phone *' : 'Phone'
  const emailLabel = profile.hasCognitoAccountWithEmail ? 'Email *' : 'Email'

  const showContactInfo = (
    <Grid container spacing={1}>
      <ContactField label="First">{profile.firstName}</ContactField>
      <ContactField label="Last">{profile.lastName}</ContactField>
      <ContactField label={emailLabel}>{profile.email}</ContactField>
      <ContactField label={phoneLabel}>{formattedPhoneNumber}</ContactField>
      <ContactField label="Modified">{formattedDate}</ContactField>
    </Grid>
  )

  return (
    <ContactSection item xs={6}>
      <CardSectionHeader>
        <Box display="flex">
          <ContactLabel>Contact Info</ContactLabel>
          {isCognito(profile) ? cognitoImage : null}
        </Box>
      </CardSectionHeader>
      {showContactInfo}
    </ContactSection>
  )
}

const isCognito = profile => {
  return (
    profile.hasCognitoAccountWithEmail || profile.hasCognitoAccountWithPhone
  )
}

export default ContactInfo
